/** Project logo — `public/logo260.png` (served at `/logo260.png` by Vite).
 *
 * A size-stable square (`objectFit: contain`) so the AppBar / Login layout stays
 * put regardless of the source aspect ratio.
 */
import { Box } from '@mui/material';

export interface BrandLogoProps {
  size?: number;
}

export function BrandLogo({ size = 32 }: BrandLogoProps) {
  return (
    <Box
      component="img"
      src="/logo260.png"
      alt="Ops Console logo"
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        flexShrink: 0,
        display: 'block',
      }}
    />
  );
}
